"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _like = _interopRequireDefault(require("../../assets/images/like.png"));

var _share = _interopRequireDefault(require("../../assets/images/share.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var media1 = 'https://homepages.cae.wisc.edu/~ece533/images/baboon.png';

var LikeShare = function LikeShare(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "like-share"
  }, /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "/#"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Like"), /*#__PURE__*/_react["default"].createElement("img", {
    src: _like["default"],
    alt: "Like"
  }))), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "/#"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Share"), /*#__PURE__*/_react["default"].createElement("img", {
    src: _share["default"],
    alt: "Share"
  })))));
};

var _default = LikeShare;
exports["default"] = _default;